module.exports = __webpack_public_path__ + "static/media/logoMultiplan.c69372b9.png";